<template>
    <v-row no-gutters>
        <v-col cols="12" sm="10" offset-sm="1">
            <span class="headline">Korisnici</span>
            <bit-page :breadcrumbs="breadcrumbs"></bit-page>
            <v-row align="center" class="white mt-3 pa-3" no-gutters>
                <span class="title green--text text--darken-3">Meni</span>
                <v-col class="d-flex mb-3" cols="12">
                    <v-divider></v-divider>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                    <v-btn depressed small tile color="success" :to="{name: 'sajtovi-create'}">Dodaj novi sajt</v-btn>
                </v-col>
                <v-col class="d-flex mt-3" cols="12">
                    <v-treeview
                            v-if="items.length"
                            open-all
                            :items="items"
                            selection-type="independent"
                            color="warning"
                            item-text="website"
                    >
                        <template v-slot:prepend="{ item }">
                            <span class="overline">ID:{{item.id}}</span>
                        </template>
                        <template v-slot:append="{ item }">
                            <span class="overline white--text px-1" :class="item.status ? 'success' : 'error'" v-html="item.status ? 'aktivan' : 'neaktivan'"></span>
                            <v-btn icon :to="{name: 'sajtovi-create', params: {item: {parent: {id: item.id, name: item.name}}, sub: true}}">
                                <v-icon small>{{'mdi-plus'}}</v-icon>
                            </v-btn>
                            <v-btn icon :to="{name: 'sajtovi-create', params: {item: item}}">
                                <v-icon small>{{'mdi-pencil'}}</v-icon>
                            </v-btn>
                        </template>
                    </v-treeview>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
    import bitPage from "../../components/layout/page";

    export default {
        components: {
            bitPage
        },
        head() {
            return {
                title: 'BitLab CMS'
            }
        },
        data: () => ({
            breadcrumbs: [
                {
                    text: 'Meni',
                    disabled: true
                },
            ],
            headers: [
                {text: 'ID', value: 'id'},
                {text: 'Name', value: 'website'},
                {text: 'Option', value: 'option'},
            ],
            items: [],
            loading: false
        }),
        created() {
            this.getUser();
        },
        methods: {
            getUser() {
                this.loading = true;
                this.axios.get('/website/all').then(res => {
                    this.items = res.data
                }).finally(()=> this.loading = false)
            }
        }
    }
</script>
